var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('NavBar'),_c('AppHeader'),_c('Visu'),_c('FabButton'),_c('GunTest'),_vm._v(" "+_vm._s(_vm.files)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }